import { graphql } from '@/gql';
import type { HomeServiceOrderProviderPaymentsQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

// Fragments
import './fragments/homeServiceOrderProviderPaymentFragment';

export const getHomeServiceOrderProviderPayments = async ({
  searchType,
  searchValue,
  pagination,
}: HomeServiceOrderProviderPaymentsQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      searchType,
      searchValue,
      pagination,
    },
    query: graphql(`
      query HomeServiceOrderProviderPayments(
        $searchType: HomeServiceOrderProviderPaymentSearchType
        $searchValue: String
        $pagination: PaginationInputType
      ) {
        homeServiceOrderProviderPayments(searchType: $searchType, searchValue: $searchValue, pagination: $pagination) {
          count
          rows {
            ...HomeServiceOrderProviderPaymentFragment
          }
        }
      }
    `),
  });

  return response.data.homeServiceOrderProviderPayments;
};
